import * as React from 'react';

import { DEFAULT_DEBOUNCE_WAIT_TIME } from '~constants/Constants';

type FunctionType<T> = (parameter: T) => void;

//Debounce a function by time
export default function useDebounce<T>(func: FunctionType<T>, delay = DEFAULT_DEBOUNCE_WAIT_TIME) {
    const setTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>();
    const clearTimer = () => {
        if (setTimerRef.current) {
            clearTimeout(setTimerRef.current);
            setTimerRef.current = null;
        }
    };

    React.useEffect(() => {
        return clearTimer();
    }, []);

    return React.useCallback(
        (parameter: T) => {
            clearTimer();
            setTimerRef.current = setTimeout(() => {
                setTimerRef.current = null;
                func(parameter);
            }, delay);
        },
        [func, delay]
    );
}
